var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, PropertyConverters, Components } from '@pacem/pacem-core';
export class PacemBaseCellElement extends Components.PacemSafeContentElement {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.updateColumnPosition();
        this.updateLayout(this.metadata);
    }
    updateColumnPosition(metadata = this.metadata, state = this.gridState) {
        this.style.gridColumn = (state.orderedColumns.indexOf(metadata.prop) + 1).toString();
    }
    updateVisibility(state = this.state) {
        this.hide = !!state.hidden;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'metadata':
                    this.updateLayout(val);
                    break;
                case 'gridState':
                    this.updateColumnPosition();
                    break;
                case 'state':
                    this.updateVisibility();
                    break;
            }
        }
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemBaseCellElement.prototype, "metadata", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemBaseCellElement.prototype, "state", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemBaseCellElement.prototype, "gridState", void 0);
